import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=50ce2fdd&"
import script from "./page404.vue?vue&type=script&lang=js&"
export * from "./page404.vue?vue&type=script&lang=js&"
import style0 from "./page404.vue?vue&type=style&index=0&id=50ce2fdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports